/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import AgentSubaccountList from "./AgentSubaccountList";

const rowPerPage = 10;

interface PayloadType {
  [key: string]: any;
}

const SubaccountsTab: React.FC<{
  detail: any;
  fetchAccountDetailToGetAssignedSubaccount: any;
  assignedSubaccountIds: any;
}> = ({ detail, fetchAccountDetailToGetAssignedSubaccount, assignedSubaccountIds }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tableData, setTableData] = useState([]);
  const [lastKeys, setLastKeys] = useState<{ [key: number]: string }>({});
  const [currentLastKey, setCurrentLastKey] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(rowPerPage);
  const [rowCount, setRowCount] = useState(rowPerPage);

  useEffect(() => {
    const fetchData = async () => {
      await fetchSubaccounts({ page: 0, limit: rowPerPage, lastkey: "", agent_id: detail.id });
    };

    if (detail !== null) {
      fetchData();
    }
  }, [detail]);

  const setPaginationModel = (newValue: any) => {
    setIsLoading(true);

    let newFilters: any = {
      page: newValue.page,
      limit: newValue.pageSize,
      lastkey: currentLastKey,
      agent_id: detail.id
    };

    if (newValue.page < page) {
      newFilters = {
        ...newFilters,
        lastkey: newValue.page !== 0 ? lastKeys[newValue.page - 1] : "",
      };
    }

    if (newValue.pageSize !== pageSize) {
      newFilters = {
        page: 0,
        limit: newValue.pageSize,
        lastkey: "",
        agent_id: detail.id
      };
      setPage(0);
      setPageSize(newValue.pageSize);
      setCurrentLastKey("");
      setLastKeys([]);
    } else {
      setPage(newValue.page);
    }

    fetchSubaccounts(newFilters);
  };

  const fetchSubaccounts = async (payload: PayloadType = {}) => {
    try {
      const queryObject: PayloadType = {
        limit: payload?.limit,
        lastkey: payload?.lastkey,
        agent_id: payload?.agent_id
      };

      const queryString = Object.keys(queryObject)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`
        )
        .join("&");

      const response = await axios.get(
        process.env.REACT_APP_API_URL +
        `/api/subaccount/get-all-subaccounts?${queryString}`
      );

      let newData = response.data.subaccounts?.payload;

      if (newData.length !== 0) {
        setTableData(newData);
      } else {
        setTableData([]);
      }
      setIsLoading(false);

      let newLastKey = response.data.receivers?.lastkey;
      if (newLastKey) {
        setCurrentLastKey(newLastKey);
        let newPage = payload?.page;
        let newPageSize = payload?.limit;

        if (newData.length !== 0) {
          setRowCount((newPage + 1) * newPageSize + newPageSize);
        } else {
          setRowCount((newPage) * newPageSize + newPageSize);
        }
        setLastKeys({ ...lastKeys, [newPage]: newLastKey });
      } else {
        setCurrentLastKey("");
      }
    } catch (error) {
      setTableData([]);
      setIsLoading(false);
      setPage(0);
      setPageSize(0);
      setRowCount(0);
      setLastKeys([]);
      setCurrentLastKey("");
      console.error("Error fetching data", error);
    }
  };

  const triggerReloadList = async () => {
    setIsLoading(true);
    fetchAccountDetailToGetAssignedSubaccount(detail.id);
    await fetchSubaccounts({ page: 0, limit: rowPerPage, lastkey: "", agent_id: detail.id });
  }

  return (
    <div>
      <AgentSubaccountList
        isLoading={isLoading}
        page={page}
        pageSize={pageSize}
        rowCount={rowCount}
        tableData={tableData}
        setPaginationModel={setPaginationModel}
        currentLastKey={currentLastKey}
        agentDetail={detail}
        triggerReloadList={triggerReloadList}
        assignedSubaccountIds={assignedSubaccountIds}
      />
    </div>
  );
};

export default SubaccountsTab;